import React, { useState } from 'react';
import Thinking from './Thinking';
import InspirationCarousel from './InspirationCarousel';
import './ProblemDescription.css';
import { motion } from "framer-motion";


const ProblemDescription = () => {
  const [context, setContext] = useState("");

  return (
    <motion.div
              className="problem-description-container"
              initial={{ opacity: 0, y: 24 }}
              animate={{ opacity: 1, y: 0 }}
              exit={{ opacity: 0, y: -24 }}
              transition={{ duration: 0.5, ease: "easeOut" }}
            >
      <Thinking value={context} onChange={setContext}/>
      <InspirationCarousel />
    </motion.div>
  );
};

export default ProblemDescription;